// extracted by mini-css-extract-plugin
export default {"iconBar":"zXWf5qx","greeterWrapper":"pdPlC2x","pageFooter":"yoIGaVj"};